"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entities_1 = require("../entities");
const type_graphql_1 = require("type-graphql");
exports.resolveIntegrationType = (obj) => {
    switch (obj.integrationType) {
        case 'Mailjet':
            return entities_1.Mailjet;
        case 'ActiveCampaign':
            return entities_1.ActiveCampaign;
        case 'Mailchimp':
            return entities_1.Mailchimp;
        case 'ContentSystem':
            return entities_1.ContentSystem;
        case 'CampaignMonitor':
            return entities_1.CampaignMonitor;
        case 'Sailthru':
            return entities_1.Sailthru;
        case 'Salesforce':
            return entities_1.Salesforce;
        default:
            return entities_1.Integration;
    }
};
exports.createIntegrationUnion = () => {
    return type_graphql_1.createUnionType({
        name: 'IntegrationItem',
        resolveType: obj => {
            switch (obj.integrationType) {
                case 'Mailjet':
                    return entities_1.Mailjet;
                case 'ActiveCampaign':
                    return entities_1.ActiveCampaign;
                case 'Mailchimp':
                    return entities_1.Mailchimp;
                case 'ContentSystem':
                    return entities_1.ContentSystem;
                case 'CampaignMonitor':
                    return entities_1.CampaignMonitor;
                case 'Sailthru':
                    return entities_1.Sailthru;
                case 'Salesforce':
                    return entities_1.Salesforce;
                default:
                    return entities_1.Integration;
            }
        },
        types: [
            entities_1.Integration,
            entities_1.Mailjet,
            entities_1.ActiveCampaign,
            entities_1.ContentSystem,
            entities_1.Sailthru,
            entities_1.Salesforce,
            entities_1.Mailchimp,
            entities_1.CampaignMonitor,
        ],
    });
};
//# sourceMappingURL=createIntegrationUnion.js.map